<template>
  <div>
    <!-- Row top buttons -->
    <div class="row q-mb-lg">
      <div class="col-6" style="justify-content: flex-start">
        <q-btn
          class="capitalize ctrl-button"
          color="grey-5"
          :label="`${$store.state.stringsStore.strings.action.toOverview}`"
          @click="$router.push('/form')"
          icon="keyboard_backspace"
        />
      </div>
      <div class="col-6">
        <q-btn  style="float: right"
          class="capitalize ctrl-button right q-ml-md"
          @click="saveChanges()"
          :color="disable ? 'grey-5' : 'ctrl-turquoise'"
          :label="disable ? getString('action.edit') : getString('action.save')"
          :icon-right="disable ? 'edit' : 'save'"
        />
        <q-btn v-if="data.id"
          class="q-ml-md capitalize ctrl-button right"
          icon-right="delete"
          color="negative capitalize"
          :label="$store.state.stringsStore.strings.action.delete"
          align="right"
          @click="deleteForm()"
        />
      </div>
    </div>

      <!-- Left -->
      <div class="col-md-6 col-sm-12 col-xs-12">
        <div class="row q-mb-sm">
          <div class="full-width">
            <p class="card-title">Details</p>

            <div class="card-block">
              <div class="row">

                <div class="col-md-4">
                  <q-input
                    class="q-mr-md"
                    color="primary"
                    :disable="disable"
                    v-model="data.name"
                    :float-label="getString('name')"/>
                </div>

                <div class="col-md-4">
                  <q-input
                    class="q-mr-md"
                    color="primary"
                    :disable="disable"
                    type="number"
                    :decimals="0"
                    v-model="data.request_subject.number"
                    float-label="Request subject number"/>
                </div>

                <div class="col-md-4">
                  <q-input
                    class="q-mr-md"
                    color="primary"
                    :disable="disable"
                    v-model="data.request_subject.subject"
                    float-label="Request subject"/>
                </div>

            </div>

          </div>
        </div>
      </div>

      <!-- Right -->
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="row q-mb-sm">
          <div class="full-width">
            <p class="card-title">
              {{ 'Fields' }}
            </p>

              <draggable
                class="full-width"
                v-model="data.fields"
                handle=".handle"
                v-bind="dragOptions"
                @start="drag = true"
                @end="drag = false"
              >
                <transition-group
                  type="transition"
                  :name="!drag ? 'flip-list' : null"
                >

                <div class="card-block q-mb-sm handle" :class="{ 'field-deleted' : field.deleted }" v-for="(field, r) in combinedFields" :key="`field-${r}`">

                  <div class="row">
                    <!-- Field type  -->
                    <div class="col-md-4">
                      <q-field class="q-mb-md q-mr-md">
                        <q-select
                          :readonly="!!field.id || field.deleted"
                          :disable="disable || field.deleted"
                          :options="fieldSelect" v-model="field.type.value"
                          :float-label="getString('module.form.fields.type')" />
                      </q-field>
                    </div>
                    <div class="col-md-4">
                      <q-field class="q-mb-md q-mr-md">
                        <q-input
                          v-model="field.label"
                          :readonly="field.deleted"
                          :disable="disable || field.deleted"
                          :float-label="'Label'" />
                      </q-field>
                    </div>
                    <div class="col-md-4">
                      <q-field class="q-mb-md q-mr-md">
                        <q-input
                          v-model="field.name"
                          lower-case
                          @input="formatFieldName(field)"
                          :readonly="field.deleted"
                          :disable="disable || field.deleted"
                          :float-label="'Name'" />
                      </q-field>
                    </div>
                    <div class="col-md-4">
                      <q-field class="q-mb-md q-mr-md">
                        <!-- Checkbox required -->
                        <q-toggle
                          class="select-text q-pa-md"
                          color="secondary"
                          v-model="field.required"
                          :label="getString('required')"
                        />
                      </q-field>
                    </div>
                  </div>

                  <!-- Add conditional properties based on the field type-->
                  <div class="row" v-if="['text', 'textarea'].includes(field.type.value)">
                  </div>

                  <div class="row">
                    <q-btn
                      :readonly="field.deleted"
                      :disable="disable || field.deleted"
                      v-if="['radio', 'checkbox'].includes(field.type.value)"
                      label="Add option"
                      color="grey-5"
                      class="ctrl-button q-mt-md capitalize"
                      @click="field.data.push({ label: '', value: '' })">
                    </q-btn>
                  </div>

                  <template v-if="['radio', 'checkbox'].includes(field.type.value)">
                    <div class="row" v-for="(item, i) in field.data" :key="`data-${i}`">

                        <div class="col-md-4">
                          <q-input
                            class="q-mr-md"
                            v-model="item.label"
                            :float-label="'Label'"
                            :readonly="field.deleted"
                            :disable="disable || field.deleted"
                          />
                        </div>
                        <div class="col-md-4">
                          <q-input
                            v-model="item.value"
                            :float-label="'Value'"
                            :readonly="field.deleted"
                            :disable="disable || field.deleted"
                          />
                        </div>
                        <q-btn
                          :readonly="field.deleted"
                          :disable="disable || field.deleted"
                          round
                          size="sm"
                          icon="clear"
                          color="negative"
                          class="q-ml-md q-mt-md capitalize"
                          @click="field.data.splice(i, 1)">
                        </q-btn>
                    </div>
                  </template>

                  <q-btn v-if="!field.deleted" class="ctrl-button capitalize q-mb-md q-mt-md" color="negative"
                  @click="removeField(r)" :label="getString('action.delete')"/>

                  <q-btn v-if="field.deleted" class="ctrl-button capitalize q-mb-md q-mt-md" color="positive"
                  @click="restoreField(r)" label="restore"/>
                </div>

              </transition-group>
            </draggable>

            <q-btn class="ctrl-button capitalize q-mb-md" color="primary"
              @click="newFields.push({ type: { value: ''}, data: [], required: false })" :label="getString('module.form.field.new')"/>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import qs from 'qs';
import draggable from 'vuedraggable';

// Mixins
import getString from '@/helpers/GetStrings';
import errorHandler from '@/mixins/detailViews/errorHandler';

export default {
  components: {
    draggable,
  },
  mixins: [
    errorHandler,
  ],
  data() {
    return {
      disable: false,
      drag: false,
      dragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      },

      data: {
        name: '',
        request_subject: {
          number: '',
          subject: '',
        },
        fields: [],
      },

      newFields: [],
      fields: [],

      // When an existing field is removed, it is added to this array for a delete on save.
      fieldsRemoved: [],

      fieldSelect: [
        {
          label: getString('module.form.field.type.text.single'),
          value: 'text',
        },
        {
          label: getString('module.form.field.type.text.multiline'),
          value: 'textarea',
        },
        {
          label: getString('module.form.field.type.radio'),
          value: 'radio',
        },
        {
          label: getString('module.form.field.type.checkbox'),
          value: 'checkbox',
        },
      ],
    };
  },

  methods: {
    getString,

    // Format the field name so that it can be used in the form on the website
    formatFieldName(field) {
      field.name = field.name.replace(/[^a-zA-Z_ ]/g, '').replace(' ', '_');
    },

    fetchForm() {
      this.axios.get(`form/${this.$route.params.id}`).then(async (res) => {
        this.data = res.data.form;
        this.data.fields = this.data.fields.map(f => ({
          id: f.id,
          label: f.label,
          name: f.name,
          required: f.required,
          type: f.type,
          data: JSON.parse(f.data),
        }));
      });
    },

    deleteForm() {
      this.axios.delete(`form/${this.$route.params.id}`).then(() => {
        this.$router.push('/form');
      });
    },
    requestParams() {
      return {};
    },

    removeField(index) {
      const field = this.combinedFields[index];
      // Move only existing fields to fieldsRemoved array.
      if (field.id) {
        this.fieldsRemoved.push(field);
        // Set deleted to true in the filtered array.
        this.$set(this.data.fields[index], 'deleted', true);
      } else {
        this.newFields.splice(index - this.data.fields.length, 1);
      }
    },

    restoreField(index) {
      const field = this.data.fields[index];
      // Remove the field from the fieldsRemoved array.
      this.fieldsRemoved = this.fieldsRemoved.filter(item => item.id !== field.id);

      this.$set(this.data.fields[index], 'deleted', false);
    },

    /**
     * Saving a form requires saving the form itself as well as each field within the form.
     */
    saveChanges() {
      if (this.$route.params.id) {
        if (this.disable) {
          this.disable = false;
          return;
        }
        this.saveExistingForm();
      } else {
        this.saveNewForm();
      }
    },

    cleanData(data) {
      Object.keys(data).forEach((key) => {
        if (!data[key] && data[key] !== false) {
          delete data[key];
        }
      });
      return data;
    },

    saveExistingForm() {
      let data = {
        name: this.data.name,
        request_subject_number: this.data.request_subject.number,
        request_subject: this.data.request_subject.subject,
      };
      data = this.cleanData(data);
      this.axios.put(`form/${this.$route.params.id}`, qs.stringify(data))
        .then(async () => {
        // Save all fields.
          await Promise.all(this.combinedFields.map((field, index) => {
          // Save all existing fields.
            if (field.id) {
              if (!field.deleted) {
                return this.saveExistingField(field, index);
              }
              return true;
            }
            // Save all new fields.
            return this.saveNewField(field, index);
          })).then(() => {
            this.newFields = [];
          }).catch((err) => {
            // Handle the error (handleError mixin)
            this.handleError(err);
          });

          // Apply deletes
          await Promise.all(this.fieldsRemoved.map(field => this.axios.delete(`form/${this.$route.params.id}/field/${field.id}`)));
          this.$q.notify({
            message: getString('module.form.edit.save.success'),
            type: 'positive',
            timeout: 1200,
            position: 'top-right',
          });
          this.fetchForm();
        }).catch((err) => {
          // Handle the error (handleError mixin)
          this.handleError(err);
        });
    },

    saveNewForm() {
      let data = {
        name: this.data.name,
        request_subject_number: this.data.request_subject.number,
        request_subject: this.data.request_subject.subject,
      };
      data = this.cleanData(data);

      this.axios.post('form', qs.stringify(data))
        .then((response) => {
        // Redirect to detail page of the newly created item
          if (response.headers && response.headers.location) {
            const location = response.headers.location.replace('/api', '');
            this.$router.push(location);
          }
        }).then(async () => {
        // Post successful, check id
          if (this.$route.params.id) {
          // id availible, post all fields.
            await Promise.all(this.combinedFields.map((field, index) => this.saveNewField(field, index))).then(() => {
              this.newFields = [];
            }).catch((err) => {
            // Handle the error (handleError mixin)
              this.handleError(err);
            });

            // Successfully saved all new fields.
            this.$q.notify({
              message: getString('module.form.edit.save.success'),
              type: 'positive',
              timeout: 1200,
              position: 'top-right',
            });
          }
        }).catch((err) => {
        // Handle the error (handleError mixin)
          this.handleError(err);
        });
    },

    saveNewField(field, index) {
      let fieldData = {
        sort_id: index + 1,
        type: field.type.value,
        label: field.label,
        name: field.name,
        required: field.required ? '1' : '0',
        data: field.data && field.data.length ? JSON.stringify(field.data) : null,
      };

      fieldData = this.cleanData(fieldData);
      return this.axios.post(`form/${this.$route.params.id}/field`, qs.stringify(fieldData, { plainObjects: true }));
    },

    saveExistingField(field, index) {
      let fieldData = {
        sort_id: index + 1,
        type: field.type.value,
        label: field.label,
        name: field.name,
        required: field.required ? '1' : '0',
        data: field.data && field.data.length ? JSON.stringify(field.data) : null,
      };

      fieldData = this.cleanData(fieldData);
      return this.axios.put(`form/${this.$route.params.id}/field/${field.id}`, qs.stringify(fieldData, { plainObjects: true }));
    },
  },

  computed: {
    combinedFields() {
      return [...this.data.fields, ...this.newFields];
    },
  },

  mounted() {
    if (this.$route.params.id) {
      this.disable = true;
      this.fetchForm();
    }
  },
};
</script>

<style lang="stylus">
.card-block.field-deleted
    background rgba(255, 255, 255, 0.5)
</style>
